"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Like = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var Icons_1 = require("../../../../v2/components/Icons");
var Icons = require("../../../DataDisplay/Icons");
/**
 * いいねの♡アイコン
 * @param {IconButtonProps} props
 * @param {boolean} liked いいねしているかどうか
 */
var Like = function (_a) {
    var liked = _a.liked, bgcolor = _a.bgcolor, color = _a.color, sx = _a.sx, badge = _a.badge, v2Icon = _a.v2Icon, props = __rest(_a, ["liked", "bgcolor", "color", "sx", "badge", "v2Icon"]);
    var palette = (0, material_1.useTheme)().palette;
    return ((0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ sx: __assign({ '&, :hover': {
                bgcolor: bgcolor !== null && bgcolor !== void 0 ? bgcolor : 'transparent',
                svg: {
                    color: liked ? 'like.tap' : (color !== null && color !== void 0 ? color : palette.grey['600']),
                },
            } }, sx) }, props, { children: (0, jsx_runtime_1.jsx)(material_1.Badge, __assign({}, badge, { children: v2Icon ? (0, jsx_runtime_1.jsx)(Icons_1.HeartIcon, { liked: liked }) : (0, jsx_runtime_1.jsx)(Icons.Like, { liked: liked }) })) })));
};
exports.Like = Like;
